import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IRailEmissionRequest } from '@ruby/modules/rail-emission/models/rail-emission.interface';
import * as RailEmissionActions from '@ruby/modules/rail-emission/store/actions/rail-emission.actions';
import * as fromRailEmission from '@ruby/modules/rail-emission/store/reducers/rail-emission.reducer';
import * as RailEmissionSelectors from '@ruby/modules/rail-emission/store/selectors/rail-emission.selectors';

@Component({
  selector: 'ng-rail-emission-container',
  templateUrl: './rail-emission.container.html',
  styleUrls: ['./rail-emission.container.scss']
})
export class RailEmissionContainer implements OnInit {
  store$: Observable<fromRailEmission.State>;

  constructor(private store: Store<fromRailEmission.State>) {
    this.store$ = this.store.select(RailEmissionSelectors.selectRailEmissionState);
  }

  ngOnInit(): void {
    this.store.dispatch(RailEmissionActions.loadEmissionFilters());
  }

  /**
   * Dispatch Emission report
   *
   * @summary Dispatch loadEmissionReport action
   * @param $data: IRailEmissionRequest
   * @returns void
   */
  dispatchEmissionReport($data: IRailEmissionRequest): void {
    this.store.dispatch(RailEmissionActions.loadEmissionReport({ data: $data }));
  }

  /**
   * Reset
   *
   * @summary Dispatch reset state action
   * @returns void
   */
  reset(): void {
    this.store.dispatch(RailEmissionActions.resetState());
  }

  /**
   * Dispatch Audit Download
   *
   * @summary Dispatch auditDownload action
   * @param $data: IRailEmissionRequest
   * @returns void
   */
  dispatchAuditDownload($data: IRailEmissionRequest): void {
    this.store.dispatch(RailEmissionActions.auditDownload({ data: $data }));
  }
}
